var map = {
	".": 32,
	"./": 32,
	"./index": 32,
	"./index.js": 32,
	"./pt-BR": 516,
	"./pt-BR/": 516,
	"./pt-BR/allOrderPage.dict": 570,
	"./pt-BR/allOrderPage.dict.js": 570,
	"./pt-BR/appBar.dict": 571,
	"./pt-BR/appBar.dict.js": 571,
	"./pt-BR/bankAccountPage.dict": 572,
	"./pt-BR/bankAccountPage.dict.js": 572,
	"./pt-BR/categoryPage.dict": 573,
	"./pt-BR/categoryPage.dict.js": 573,
	"./pt-BR/companiesPage.dict": 574,
	"./pt-BR/companiesPage.dict.js": 574,
	"./pt-BR/crudCard.dict": 575,
	"./pt-BR/crudCard.dict.js": 575,
	"./pt-BR/dashPage.dict": 576,
	"./pt-BR/dashPage.dict.js": 576,
	"./pt-BR/index": 516,
	"./pt-BR/index.js": 516,
	"./pt-BR/itemProductPage.dict": 577,
	"./pt-BR/itemProductPage.dict.js": 577,
	"./pt-BR/linkPlacesCompaniesPage.dict": 578,
	"./pt-BR/linkPlacesCompaniesPage.dict.js": 578,
	"./pt-BR/listProductsInPreparationPage.dict": 579,
	"./pt-BR/listProductsInPreparationPage.dict.js": 579,
	"./pt-BR/loginPage.dict": 580,
	"./pt-BR/loginPage.dict.js": 580,
	"./pt-BR/messagePage.dict": 581,
	"./pt-BR/messagePage.dict.js": 581,
	"./pt-BR/orderListPage.dict": 582,
	"./pt-BR/orderListPage.dict.js": 582,
	"./pt-BR/orderPage.dict": 583,
	"./pt-BR/orderPage.dict.js": 583,
	"./pt-BR/orderPanelPage.dict": 584,
	"./pt-BR/orderPanelPage.dict.js": 584,
	"./pt-BR/placesPage.dict": 585,
	"./pt-BR/placesPage.dict.js": 585,
	"./pt-BR/productsPage.dict": 586,
	"./pt-BR/productsPage.dict.js": 586,
	"./pt-BR/registerPage.dict": 587,
	"./pt-BR/registerPage.dict.js": 587,
	"./pt-BR/settingsItemsPage.dict": 588,
	"./pt-BR/settingsItemsPage.dict.js": 588,
	"./pt-BR/settingsPage.dict": 589,
	"./pt-BR/settingsPage.dict.js": 589,
	"./pt-BR/sideModal.dict": 590,
	"./pt-BR/sideModal.dict.js": 590,
	"./pt-BR/storeOrderPage.dict": 591,
	"./pt-BR/storeOrderPage.dict.js": 591,
	"./pt-BR/table.dict": 592,
	"./pt-BR/table.dict.js": 592,
	"./pt-BR/userListPage.dict": 593,
	"./pt-BR/userListPage.dict.js": 593,
	"./pt-BR/userPDVPage.dict": 594,
	"./pt-BR/userPDVPage.dict.js": 594
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 746;